import { Injectable, inject } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { AsyncValidator, registerAsyncValidatorDecorator } from "@recursyve/ngx-form-generator";
import { isDefined } from "@recursyve/nice-ts-utils";
import { Observable, of, timer } from "rxjs";
import { map, switchMap } from "rxjs/operators";

import { ApiService } from "../../../../../../api/api.service";

export function SupplierSlugIsUnique(): PropertyDecorator {
    return registerAsyncValidatorDecorator({
        name: "SupplierSlugIsUniqueValidator"
    });
}

@Injectable()
export class SupplierSlugIsUniqueValidator extends AsyncValidator {
    private readonly apiService = inject(ApiService);

    public readonly name = "SupplierSlugIsUniqueValidator";

    public validate(control: AbstractControl): Observable<ValidationErrors | null> {
        const controlValue: unknown = control.value;
        if (!isDefined(controlValue) || typeof controlValue !== "string" || controlValue === "") {
            return of(null);
        }

        return timer(200).pipe(
            switchMap(() =>
                this.apiService.suppliers.slugExists(controlValue).pipe(
                    map((isNewSupplierSlugValid) => {
                        if (!isNewSupplierSlugValid) {
                            control.markAsTouched();
                            return { supplier_slug_already_used: true };
                        }

                        return null;
                    })
                )
            )
        );
    }
}
